import { useJobTemplates } from '@/api/Jobs';
import { JobTemplate } from '@/types';
import { CustomColumns, CustomTable } from '@/ui/components/CustomTable';
import React, { FC, useMemo } from 'react';
import { JobItemTemplatesDataGrid } from '../JobItemTemplatesDataGrid';

export const JobTemplatesDataGrid: FC = () => {
  const { data: jobTemplates, isFetching: isJobTemplatesLoading } =
    useJobTemplates();

  const columns: CustomColumns<JobTemplate> = useMemo(
    () => [
      {
        dataIndex: 'name',
        title: 'Name',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        dataIndex: 'jobTypeDescription',
        title: 'Job Type',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        dataIndex: 'description',
        title: 'Description',
        sortable: true,
        filter: true,
        width: 250,
      },
    ],
    [],
  );

  return (
    <CustomTable
      dataSource={jobTemplates || []}
      columns={columns}
      rowKey="jobTemplateId"
      loading={isJobTemplatesLoading}
      expandable={{
        expandedRowRender: (data) => (
          <JobItemTemplatesDataGrid jobTemplateId={data.jobTemplateId} />
        ),
      }}
    />
  );
};
